import React, { useState } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { IoMdGift } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import NewFormWizard from '../../../../components/formWizard/NewFormWizard';
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild';
import Layout from '../../../../components/layouts/Layout';
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import http from '../../../../config/BaseUrl';
import { eventIncentiveOffers } from '../slice/createEventSlice';
import IncentiveFormItem from './module/incentiveOffer/IncentiveFormItem';

const IncentiveOffer = () => {

    const history = useHistory();
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)

    const { incentive_offer, event_option, eventId } = useSelector(state => state.createEvent)

    const { register, handleSubmit, control, formState: { errors } } = useForm({
        defaultValues: {
            description: incentive_offer && incentive_offer.description ? incentive_offer.description : '',
            incentive_offer: incentive_offer && incentive_offer.incentive_offer ?
                incentive_offer.incentive_offer
                :
                [
                    { offer_name: "", uses_limit: "", expire_in: "" },
                    { offer_name: "", uses_limit: "", expire_in: "" },
                    { offer_name: "", uses_limit: "", expire_in: "" }
                ]
        }
    })
    const { fields, append, remove, } = useFieldArray({ control, name: "incentive_offer" })

    const appendForm = () => {
        let totalFields = 12
        let currentFields = fields.length
        let extededItem = totalFields - currentFields
        if (currentFields < totalFields) {
            if (extededItem > 3) {
                for (let i = 0; i < 3; i++) {
                    append({ offer_name: "", uses_limit: "", expire_in: "" })
                }
            }
            else {
                for (let i = 0; i < extededItem; i++) {
                    append({ offer_name: "", uses_limit: "", expire_in: "" })
                }
            }
        }
    }

    const onSubmit = async (data) => {
        let offer = {
            eventId: eventId,
            incentive_offer: data.incentive_offer,
            description: data.description
        }
        // let dataItem = [...data.incentive_offer]
        dispatch(eventIncentiveOffers(JSON.stringify(data)))

        try {
            setLoading(true)
            await http.post('incentive-offer', offer).then((res) => {
                setLoading(true)
                if (res.data) {
                    if (event_option.filters === true) { history.push('/event/filter', eventId) }
                    else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                    else { history.push('/event/summary', eventId) }
                }
            }).catch((err) => {
                setLoading(false)
            })
        } catch (error) {
            setLoading(false)
        }
    };



    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            let offer = {
                eventId: eventId,
                incentive_offer: data.incentive_offer
            }
            let dataItem = [...data.incentive_offer]
            dispatch(eventIncentiveOffers(JSON.stringify(dataItem)))
            setDraftLoading(true)
            http.post('incentive-offer', offer).then(res => {
                if (res.data) {
                    setDraftLoading(false)
                }
            }).catch(err => {
                setDraftLoading(false)
            })

        })()
    }

    const BackToPreviousPage = (e) => {
        e.preventDefault()
        if (event_option.boomerang_frame_option === true) { history.push('/event/boomerang-frame') }
        else if (event_option.video_frame_option === true) { history.push('/event/video-frame') }
        else if (event_option.frame_option === true) { history.push('/event/frame') }
        else if (event_option.microsite === true) { history.push('/event/microsite') }
        else if (event_option.water_mark === true) { history.push('/event/custom-branding') }
        else if (event_option.digital_props === true) { history.push('/event/digital-prop') }
        else if (event_option.text_messaging === true) { history.push('/event/sms') }
        else if (event_option.email === true) { history.push('/event/email') }
        else if (event_option.brust_gif === true) { history.push('/event/brust-gif') }
        else if (event_option.gif === true) { history.push('/event/gif') }
        else if (event_option.social_media === true) { history.push('/event/social') }
        else { history.push('/event/options') }
    }

    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Incentives & Offers</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mt-2 mb-3 row justify-content-center">
                        <div className="col-md-10">
                            <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <IoMdGift size={30} />
                                        <p className="mb-0 ml-2 font-size-16">Incentives & Offers</p>
                                    </div>
                                    <div className="float-right">
                                        <button
                                            type="button"
                                            className="mr-3 btn btn-outline-primary"
                                            onClick={appendForm}
                                        >ADD</button>

                                    </div>
                                </div>

                                <div className="offer-description mt-3 pt-3 border-top">
                                    <div className="form-group mb-0">
                                        <textarea
                                            className="form-control"
                                            placeholder="Write the promotional message here to attract your customers"
                                            rows="6"
                                            {...register('description', { required: "This is required." })}>
                                        </textarea>
                                        <span className="text-danger font-size-14">{errors.description && errors.description.message}</span>
                                    </div>
                                </div>

                                <div className="prop__area">
                                    <div>
                                        {fields.map((item, index) => {
                                            return (
                                                <IncentiveFormItem 
                                                    key={`offer-form-${index}`}
                                                    idx={index} 
                                                    register={register} 
                                                    errors={errors} 
                                                    control={control}
                                                    remove={remove} />
                                            )
                                        })}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }
                            {
                                loading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default IncentiveOffer
